import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import {connect} from '../../../../../redux/utils'
import {DateFormat} from '../../../../../date_format'
import {getStartDate} from '../../chooser/selectors'
import {getMaxFreeUsers} from '../../../selectors'

class FreeOrderSummary extends TemplateView {
    constructor() {
        super()

        this.state = {
            maxFreeUsers: 0,
            startDate: new Date(),
        }

        this.onStatePropertyChanged('maxFreeUsers', (maxFreeUsers) => {
            this.$users.text(messageResource.getMessage('licenses.purchase_lightbox.check.users_for_free', [maxFreeUsers]))
        })

        this.onStatePropertyChanged('startDate', (startDate) => {
            this.$period.text(messageResource.getMessage('licenses.purchase_lightbox.check.free_from', [this.dateFormatter.formatDate(startDate)]))
        })
    }

    templateHtml() {
        return '<div class="orderSummaryComponent freeOrder">' +
               '    <div class="orderHeader"><%=orderSummary%></div>' +
               '    <div class="summarySection">' +
               '        <div class="users"/>' +
               '        <div class="period"/>' +
               '    </div>' +
               '    <div class="totalSection">' +
               '        <div class="free"><%=free%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            orderSummary: 'licenses.purchase_lightbox.check.order_summary',
            free: 'licenses.chooser.free',
        }
    }

    afterRender() {
        this.$users = this.find('.summarySection .users')
        this.$period = this.find('.summarySection .period')

        this.dateFormatter = new DateFormat('MMM dd, yyyy')
    }
}

export default connect(
    (state) => ({
        startDate: getStartDate(state),
        maxFreeUsers: getMaxFreeUsers(state),
    }),
)(FreeOrderSummary)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/orderSummary/FreeOrderSummary.js